import {Logger} from "platform/logger/Logger";

export abstract class Engine {

    protected readonly _logger: Logger = Logger.Of(this.constructor.toString().match(/\w+/g)[1]);

    public async setup(): Promise<void> {}
}
